<script>
	import Compete from './../layouts/partials/Compete.svelte';
	import FormatDetails from './Format_details.svelte';
	import SigninInsider from './../layouts/partials/SigninInsider.svelte';
	import Format from '../layouts/partials/Format.svelte';
	import {User} from '../models/user';
	import Video from '../components/Video.svelte';
	import Project from '../models/project';
	import CompatingHomeSlider from '../components/CompatingHomeSlider.svelte';
	import { Router, Route, Redirect, Fallback, getHistory, Layout } from 'swheel';
	import Matches from '../models/matches';
	import { Swiper, SwiperSlide } from 'swiper/svelte';
	import { onMount } from 'svelte';
	import Insider from '../layouts/partials/Insider.svelte';
	import Contest from '../layouts/partials/Contest.svelte';
    import HomePageVideos from '../components/HomePageVideos.svelte';
	const user = User.getUser();

	const urlParams = new URLSearchParams(window.location.search);
	if(urlParams.get('r') != null){
		window.localStorage.setItem('referral', urlParams.get('r'));
	}
	console.log($Project.registrationsOpen);
	let roundStats;
	Matches.get('rounds/stats/628340b04ff9fb0cdc082df2').then(res => {
		roundStats = res;
	});
</script>
<section class="main-section">
	<div class="container-fluid">
		<!-- <div class="game-pic"></div> -->
		<div class="row">
			<div class="col-md-6">
				<div class="left-charector"> 
					<img src="images/char@2x.png" alt="home-logo" class="main-logo-img mobile-none">
				</div>
			</div>
			<div class="col-md-4">
				<div class="content-wrapper">
					<div class="main-logo">
						<img src="images/event-logo.png" alt="home-logo" class="main-logo-img">
					</div>
					<div class="main-title-block">
						{#if !$Project.comingsoonOpen}
							<div class="winnig-price">
								<div class="price-txt">
									PRIZE POOL
								</div>
								<div class="winner-label">
									<!-- ₹ 50,00,000 -->
									<img src="images/5-lakhs.png" alt="prize">
								</div>
							</div>
							{:else}
							<div class="winnig-price">
								<div class="coming-soon-text">
									COMING SOON!
								</div>
							</div>
							{/if}
							<!-- <div class="hash-tag">#seizethemoment</div> -->
					</div>
					<div class="branding-logo">
						<img src="images/poco-logo-yellow@2x.png" alt="">
						<p>Snapdragon is a product of Qualcomm Technologies, Inc. and/or its subsidiaries.
							The Snapdragon Conquest tournament is sponsored by Qualcomm Technologies Inc. and/or its subsidiaries.</p>
					</div>
					{#if !$Project.comingsoonOpen}
						<!-- <div class="banner-bttom mt-40">
							{#if $Project.registrationsOpen}
								<a href="/login" class="btn btn-primary register-btn ">
									{$user.loggedOut ?  'Register Now' : 'Go to dashboard'}
								</a>
							{:else}
								<a href="/login" class="btn btn-primary register-btn ">
									Go to dashboard
								</a>
								<h3 class="reg-closed-text">Registration are closed</h3>
							{/if}
						</div> -->
						{:else}
						<!-- <div class="hash-tag">#seizethemoment</div> -->
					{/if}

				</div>
			</div>
		</div>
		<!-- <div class="game-pic game-pic-right"></div> -->
	</div>
	<div class="hills-layer">
		<img src="images/hills-layer.png" alt="">
	</div>
</section>
<section class="social-links-top">
	<div class="container text-center">
		<h6>Follow Snapdragon Conquest on</h6>
		<ul>
			<li>
				<a href="https://www.facebook.com/snapdragonconquest/" target="_blank">
					<img src="images/ic-facebook.svg" alt="Facebook">
				</a>
			</li>
			<!-- <li>
				<a href="https://discord.gg/xzVbszXD48" target="_blank">
					<img src="images/discord_2.svg" alt="Youtube">
				</a>
			</li> -->
			<li>
				<a href="https://www.instagram.com/snapdragonconquest/" target="_blank">
					<img src="images/ic-instagram.svg" alt="Instagram">
				</a>
			</li>
			<li>
				<a href="https://twitter.com/_ConquestEsport" target="_blank">
					<img src="images/ic-twitter.svg" alt="Twitter">
				</a>
			</li>
			<li>
				<a href="https://www.youtube.com/channel/UCqfsjVyKK2_ajIgG_HqR36w" target="_blank">
					<img src="images/ic-youtube.svg" alt="Youtube">
				</a>
			</li>
		</ul>
	</div>
</section>

<!-- <SigninInsider /> -->
<!-- <FormatDetails /> -->
<!-- <Compete /> -->
<!-- <section class="compating-home-section">
	<div class="container">
		<div class="row">
			<div class="col">
				<div class="text-center">
					<h1 class="format-title copit-title">
						Competing Teams
					</h1>
				</div>
			</div>
			<div class="col fade-corners">
				{#if roundStats}
					<CompatingHomeSlider>
						{#if roundStats.teams && roundStats.teams.length > 0}
							{#each roundStats.teams as team}
								<SwiperSlide ><img on:click={e=>window.location = '/team/'+team.id} src={team.Logo ? team.Logo.url : ""} alt=""></SwiperSlide>
							{/each}
						{/if}
					</CompatingHomeSlider>
				{/if}
			</div>
		</div>
	</div>
</section> -->
<style>
	.reg-closed-text {
		color: #ffffff;
	}

	.scmo-glow-neon {
		margin: 0 auto;
		position: relative;
		z-index: 2;
	}
	
</style>